const GET_ASSET_NUMBER_VALUE = 'GET_ASSET_NUMBER_VALUE';
const SET_ASSET_NUMBER_VALUE = 'SET_ASSET_NUMBER_VALUE';
const GET_TRANSFER_ASSET_DETAILS = 'GET_TRANSFER_ASSET_DETAILS';
const SET_TRANSFER_ASSET_DETAILS = 'SET_TRANSFER_ASSET_DETAILS';
const SET_ASSET_ERROR = "SET_ASSET_ERROR";
const GET_REACTIVATION_ASSET_DETAILS = "GET_REACTIVATION_ASSET_DETAILS"
const SET_REACTIVATION_ASSET_DETAILS = "SET_REACTIVATION_ASSET_DETAILS"
const GET_FLEET_ASSET_VALIDATION = "GET_FLEET_ASSET_VALIDATION"
const SET_FLEET_ASSET_VALIDATION = "SET_FLEET_ASSET_VALIDATION"
const SET_FLEET_Item_Id = "SET_FLEET_Item_Id"

export
{
    GET_ASSET_NUMBER_VALUE,
    SET_ASSET_NUMBER_VALUE,
    GET_TRANSFER_ASSET_DETAILS,
    SET_TRANSFER_ASSET_DETAILS,
    SET_ASSET_ERROR,
    GET_REACTIVATION_ASSET_DETAILS,
    SET_REACTIVATION_ASSET_DETAILS,
    GET_FLEET_ASSET_VALIDATION,
    SET_FLEET_ASSET_VALIDATION,
    SET_FLEET_Item_Id
};
